import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-no-data',
  standalone: true,
  imports: [],
  templateUrl: './no-data.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './no-data.component.scss'
})
export class NoDataComponent {

}
